import { RootGetters } from 'stores/type';
import { CustomEvents } from 'types';
import { TrackingMethods, EventHandler, WatcherHandler } from './types';


const CHECK_PROGRESS = ['4', '5', '6', '10', '20', '30', '50', '75', '100', '150', '200', '250', '300', '400', '500'];
export const getProgressLevel = (current: number): string | null => {
  const levelIndex = CHECK_PROGRESS.findIndex((progress) => {
    if (+progress <= current) {
      return false;
    }

    return true;
  }) || -1;

  if (levelIndex === -1) return null;

  return CHECK_PROGRESS[levelIndex - 1];
};

export const event = <T extends keyof CustomEvents>(
  trigger: T,
  handle: (methods: TrackingMethods, data: CustomEvents[T]) => void,
): EventHandler<T> => ({
    trigger,
    handle,
  });

export const watch = <T>(
  watcher: (getters: RootGetters) => T,
  handle: (methods: TrackingMethods, data: T) => void,
): WatcherHandler<T> => ({
    watcher,
    handle,
  });
